import React from 'react';

/** Индикатор ожидания. Цвет наследуется от текста, поэтому подходит и на кнопке, и на карточке. */
const Spinner = ({ size = 20, className = '' }) => (
    <svg
        className={`animate-spin ${className}`}
        style={{ width: size, height: size }}
        viewBox="0 0 24 24"
        fill="none"
        role="status"
        aria-label="Загрузка"
    >
        <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="3" className="opacity-20" />
        <path
            d="M12 2a10 10 0 0 1 10 10"
            stroke="currentColor"
            strokeWidth="3"
            strokeLinecap="round"
        />
    </svg>
);

export default Spinner;
